<div>
  <form [formGroup]="esignDetails">
    <div>
      <div class="card card_outLine mt-3">
        <div class="card-body">
          <div class="default-flex">
            <h5 *ngIf="!contractType" class="title_five">
              Signing details
            </h5>

            <div *ngIf="showESignSettings && isEsigned" class="flex_row ms-4">
              <span class="form_field me-3">E-Sign Settings : </span>
              <div
                class="flex_row p-field-radiobutton radio_btn ms-1 me-2"
                pTooltip="Will populate the values which are present in setting E-Sign Details"
                tooltipPosition="bottom"
              >
                <input
                  type="radio"
                  id="default"
                  name="toBeDefault"
                  [(ngModel)]="isDefault"
                  [value]="true"
                  formControlName="toBeDefault"
                  (change)="tobeDefault(true)"
                />
                <label class="me-1 ms-1 font_size_12" for="default">Default</label>
              </div>
              <div
                class="flex_row p-field-radiobutton radio_btn ms-3 me-4"
                pTooltip="Will Need to Enter the E-Sign values Manually"
                tooltipPosition="bottom"
              >
                <input
                  type="radio"
                  id="custom"
                  name="toBeDefault"
                  [(ngModel)]="isDefault"
                  [value]="false"
                  formControlName="toBeDefault"
                  (change)="tobeDefault(false)"
                />
                <label class="me-1 ms-1 font_size_12" for="custom">Custom</label>
              </div>
            </div>
          </div>

          <div *ngIf="!contractType" class="form_outline_sty mt-2">
            <div class="row">
              <div *ngIf="showESignOptions" class="col-lg-3 col-md-6 col-12">
                <div class="mb-3">
                  <p style="font-size: 0.7rem">
                    Do you want the Document to be e-signed ?
                  </p>
                </div>
                <div class="flex_row">
                  <div class="flex_row p-field-radiobutton radio_btn">
                    <input
                      type="radio"
                      id="esignedYes"
                      name="toBeESigned"
                      (click)="tobeEsigned(true)"
                      formControlName="toBeESigned"
                      [value]="esignedYes"
                    />
                    <label class="me-1 ms-1 font_size_12" for="esignedYes">Yes</label>
                  </div>
                  <div class="flex_row p-field-radiobutton radio_btn ms-3">
                    <input
                      type="radio"
                      id="esignedNo"
                      name="toBeESigned"
                      (click)="tobeEsigned(false)"
                      formControlName="toBeESigned"
                      [value]="esignedNo"
                    />
                    <label class="me-1 ms-1 font_size_12" for="esignedNo">No</label>
                  </div>
                </div>
              </div>
              <div *ngIf="isEsigned && !hideSequentialSignature" class="col-lg-3 col-md-6 col-12">
                <div class="mb-3">
                  <p style="font-size: 0.7rem">
                    Do you want to assign Signing Order?
                  </p>
                </div>
                <div class="flex_row">
                  <div class="flex_row p-field-radiobutton radio_btn">
                    <input
                      type="radio"
                      id="orderSortYes"
                      name="setOrder"
                      [formControl]="orderControl"
                      [value]="true"
                    />
                    <label class="me-1 ms-1 font_size_12" for="orderSortYes">Yes</label>
                  </div>
                  <div class="flex_row p-field-radiobutton radio_btn ms-3">
                    <input
                      type="radio"
                      id="orderSortNo"
                      name="setOrder"
                      [formControl]="orderControl"
                      [value]="false"
                    />
                    <label class="me-1 ms-1 font_size_12" for="orderSortNo">No</label>
                  </div>
                </div>
              </div>
              <div *ngIf="isEsigned && showSchedule" class="col-lg-3 col-md-6 col-12">
                <div class="mb-3">
                  <p style="font-size: 0.7rem">
                    Do you want to Schedule your Signature ?
                  </p>
                </div>
                <div class="flex_row">
                  <div class="flex_row p-field-radiobutton radio_btn">
                    <input
                      type="radio"
                      id="scheduleMailYes"
                      name="setMailSchedule"
                      (click)="showScheduleEmail(true)"
                      formControlName="setMailSchedule"
                      [value]="scheduleMailYes"
                    />
                    <label class="me-1 ms-1 font_size_12" for="toOrder">Yes</label>
                  </div>
                  <div class="flex_row p-field-radiobutton radio_btn ms-3">
                    <input
                      type="radio"
                      id="scheduleMailNo"
                      name="setMailSchedule"
                      (click)="showScheduleEmail(false)"
                      formControlName="setMailSchedule"
                      [value]="scheduleMailNo"
                    />
                    <label class="me-1 ms-1 font_size_12" for="toOrder">No</label>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-12">
                <div class="mb-3">
                  <p style="font-size: 0.7rem">
                    Do you want admin notification emails?
                  </p>
                </div>
                <div class="flex_row">
                  <div class="flex_row p-field-radiobutton radio_btn">
                    <input
                      type="radio"
                      id="carboncopyYes"
                      name="setCarbonCopy"
                      [value]="true"
                      formControlName="setCarbonCopy"
                      (click)="setCarbonCopy(true)"
                    />
                    <label class="me-1 ms-1 font_size_12" for="carboncopyYes">Yes</label>
                  </div>
                  <div class="flex_row p-field-radiobutton radio_btn ms-3">
                    <input
                      type="radio"
                      id="carboncopyNo"
                      name="setCarbonCopy"
                      [value]="false"
                      formControlName="setCarbonCopy"
                      (click)="setCarbonCopy(false)"
                    />
                    <label class="me-1 ms-1 font_size_12" for="carboncopyNo">No</label>
                  </div>
                </div>
              </div>

            <div class="col-lg-3 col-md-6 col-12" *ngIf="isInfiniteCorp" [formGroup]="esignDetails">
              <div class="mb-3">
                <p style="font-size: 0.7rem">
                  Do you want to add Default signature?
                </p>
              </div>
              <div class="flex_row">
                <div class="flex_row p-field-radiobutton radio_btn">
                  <input
                    type="radio"
                    id="defaultSignatureYes"
                    name="addDefaultSignature"
                    [value]="true"
                    formControlName="addDefaultSignature"
                    (click)="onToggleDefaultSignature(true, $event)" 
                  />
                  <label class="me-1 ms-1 font_size_12" for="defaultSignatureYes">Yes</label>
                </div>
                <div class="flex_row p-field-radiobutton radio_btn ms-3">
                  <input
                    type="radio"
                    id="defaultSignatureNo"
                    name="addDefaultSignature"
                    [value]="false"
                    formControlName="addDefaultSignature"
                    (click)="onToggleDefaultSignature(false, $event)"
                  />
                  <label class="me-1 ms-1 font_size_12" for="defaultSignatureNo">No</label>
                </div>
              </div>
            </div>
            </div>
          </div>

          <div *ngIf="isCarbonCopy" class="form_outline_sty mt-2">
            <div class="row">
              <div class="col-11" style="display: flex">
                <div
                  *ngFor="let emailControl of getCarbonCopyControls(); let i = index"
                  class="col-lg-4 col-sm-4 col-md-4"
                >
                  <span class="form_field me-2">
                    {{ i === 0 ? "First admin email" : "Second admin email" }}
                    <span class="color_red">*</span>
                  </span>
                  <div class="form_inputFields" style="display: flex; margin-top: 10px">
                    <input
                      class="form-control edit_input"
                      placeholder="Enter email"
                      pInputText
                      [formControlName]="'carbon_copy_' + i"
                      type="text"
                    />
                    <div class="col-lg-1 col-sm-1 col-md-1 order_btn">
                      <button
                        *ngIf="i === 1"
                        type="button"
                        class="p-button-delete"
                        (click)="removeCarbonCopy(i)"
                      >
                        <i class="pi pi-trash"></i>
                      </button>
                      <button
                        *ngIf="i === 0 && carbonCopyControlsCount === 1"
                        type="button"
                        class="p-button-add"
                        (click)="addCarbonCopy()"
                      >
                        <i class="pi pi-plus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="col-12 mt-1" *ngIf="hasInvalidEmails() || hasDuplicateEmails()">
                    <div *ngIf="hasInvalidEmails()" class="p-error" style="font-size: 0.65rem">
                      EmailID is not valid
                    </div>
                    <div *ngIf="hasDuplicateEmails()" class="p-error" style="font-size: 0.65rem">
                      Duplicate emails are not allowed
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="contractType && isEsigned && sameEsignValues">
            <form [formGroup]="dynamicForm">
              <div class="form_outline_sty">
                <strong class="m-1 mt-2 title_header_0">Financial Sign Details</strong>
                <div class="row form_inputFields">
                  <div *ngFor="let item of formData" class="col-12 col-md-4">
                    <div *ngFor="let key of objectKeys(item)">
                      <div *ngIf="item[key]?.module === 'esign'">
                        <ng-container [ngSwitch]="item[key]?.data_type">
                          <span class="form_field">{{ item[key]?.label }}</span>
                          <span class="color_red" *ngIf="item[key]?.mandatory">*</span>
                          <div class="flex_row custom-input">
                            <input
                              *ngSwitchCase="'text'"
                              class="form-control"
                              [formControlName]="key"
                              [placeholder]="item[key]?.label"
                              type="text"
                              pInputText
                            />
                          </div>
                          <div class="flex_row custom-input">
                            <select *ngSwitchCase="'dropdown'" [formControlName]="key" class="form-select">
                              <option value="" disabled selected>Select {{ item[key]?.label }}</option>
                              <option *ngFor="let option of item[key]?.options" [value]="getOptionKey(option)">
                                {{ getOptionValue(option) }}
                              </option>
                            </select>
                          </div>
                          <div class="flex_row custom-input">
                            <input
                              *ngSwitchCase="'date'"
                              type="date"
                              pInputText
                              class="form-control"
                              [placeholder]="item[key]?.label"
                              [formControlName]="key"
                            />
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div *ngIf="isEsigned">
            <div class="row mt-2 form_inputFields">
              <div *ngIf="showSignaotryDetails" class="col-12 mt-2">
                <h5 class="title_five">Signatory Details</h5>

                <div formArrayName="addPartyDetailsForm">
                  <section
                    #signatoryRow
                    class="signatory-row"
                    *ngFor="let details of partyDetailsArray().controls; let partyDetailsIndex = index; trackBy: trackByControl"
                    [formGroupName]="partyDetailsIndex"
                  >
                    <div class="form_outline_sty">
                      <div class="row">
                        <div *ngIf="!contractType && displayOrderIndex" class="col-lg-1 col-md-2 col-12">
                          <div class="order-control">
                            <div class="order-field">
                            <span class="form_field">Order</span><span class="color_red">*</span>
                            <input
                              class="form-control edit_input"
                              formControlName="signatory_sequence"
                              (keypress)="numberOnly($event)"
                              (change)="orderChange(partyDetailsIndex, 'PARTY')"
                              [min]="1"
                              pInputText
                              type="text"
                              readonly="true"
                            />
                            </div>
                          <div class="order_btn">
                            <button
                              *ngIf="partyDetailsIndex != 0"
                              pButton
                              pRipple
                              type="button"
                              icon="pi pi-angle-double-up"
                              (click)="decreseOrder(partyDetailsIndex, 'PARTY')"
                              class="p-button-sm ms-1"
                            ></button>
                            <button
                              pButton
                              pRipple
                              type="button"
                              icon="pi pi-angle-double-down"
                              (click)="increaseOrder(partyDetailsIndex, 'PARTY')"
                              class="p-button-sm ms-1 mt-1"
                            ></button>
                          </div>
                        </div>
                        </div>

                        <div class="col">
                          <div class="row">
                            <div class="col-lg-4 col-sm-12 col-md-6">
                              <span class="form_field">{{ partyDetailsIndex + 1 }} Signatory Name</span>
                              <span class="color_red">*</span>
                              <span
                                class="adhar-message"
                                *ngIf="selectedSignMethod === 'AADHAAR' && isDocumentType === '003'"
                              >Signatory Name as per Aadhar Name</span>
                              <input
                                class="form-control edit_input"
                                formControlName="name"
                                placeholder="Enter Name"
                                pInputText
                                type="text"
                              />
                              <span
                                class="p-error"
                                *ngIf="submitted && partyDetailsArray().at(partyDetailsIndex).get('name')?.hasError('required')"
                              >*Enter Signatory Name</span>
                              <span
                                class="p-error"
                                *ngIf="submitted && partyDetailsArray().at(partyDetailsIndex).get('name')?.hasError('maxLength')"
                              >*Maximum of 50 characters</span>
                            </div>
                            <div class="col-lg-4 col-sm-4 col-md-4">
                              <span class="form_field">{{ partyDetailsIndex + 1 }} Signatory email</span>
                              <input
                                class="form-control edit_input"
                                formControlName="email"
                                placeholder="Enter Email"
                                (input)="onEmailChange($event)"
                                pInputText
                                type="email"
                              />
                              <span
                                class="p-error"
                                *ngIf="
                                  submitted &&
                                  partyDetailsArray().at(partyDetailsIndex)?.hasError('emailOrContactRequired') &&
                                  !partyDetailsArray().at(partyDetailsIndex).get('email')?.value &&
                                  !partyDetailsArray().at(partyDetailsIndex).get('contact_number')?.value
                                "
                              >Either Email or Mobile Number is required.</span>
                              <span
                                class="p-error"
                                *ngIf="partyDetailsArray().at(partyDetailsIndex).get('email')?.hasError('email')"
                              >Email must be a valid format.</span>
                              <span
                                class="p-error"
                                *ngIf="partyDetailsArray().at(partyDetailsIndex).get('email')?.hasError('invalidEmail')"
                              >Email must include a valid domain</span>
                            </div>
                            <div class="col-lg-4 col-sm-4 col-md-4">
                              <span class="form_field">{{ partyDetailsIndex + 1 }} Signatory Mobile</span>
                              <span class="color_red" *ngIf="contractType">*</span>
                              <input
                                class="form-control edit_input"
                                formControlName="contact_number"
                                placeholder="Enter Number"
                                pInputText
                                type="text"
                                (keypress)="numberOnlyForContact($event)"
                                [maxlength]="10"
                                [minlength]="10"
                              />
                              <span
                                class="p-error"
                                *ngIf="
                                  submitted &&
                                  partyDetailsArray().at(partyDetailsIndex)?.hasError('emailOrContactRequired') &&
                                  !partyDetailsArray().at(partyDetailsIndex).get('email')?.value &&
                                  !partyDetailsArray().at(partyDetailsIndex).get('contact_number')?.value
                                "
                              >Either Email or Mobile Number is required.</span>
                              <span
                                class="p-error"
                                style="font-size: 0.5rem"
                                *ngIf="
                                  partyDetailsArray().at(partyDetailsIndex).get('contact_number')?.hasError('maxlength') ||
                                  partyDetailsArray().at(partyDetailsIndex).get('contact_number')?.hasError('minlength')
                                "
                              >*Enter Valid Mobile Number</span>
                            </div>
                          </div>

                          <div class="row mt-1">
                            <div class="col-lg-4 col-sm-4 col-md-4 overlay_Z_1">
                              <div>
                                <span class="form_field">Select {{ partyDetailsIndex + 1 }} Signatory Sign Method</span>
                                <span class="color_red">*</span>
                                <app-dropdown
                                  class="custom-dropdown"
                                  [options]="signMethod"
                                  formControlName="method"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select"
                                  [autoDisplayFirst]="false"
                                  optionDisabled="inactive"
                                  (onChange)="onSignMethodChange($event, partyDetailsIndex)"
                                  [ngClass]="{'ng-invalid ng-dirty': submitted && partyDetailsArray().at(partyDetailsIndex).get('method')?.errors}"
                                ></app-dropdown>
                              </div>
                              <span
                                class="p-error"
                                style="font-size: 0.5rem; margin-top: 0.5rem"
                                *ngIf="submitted && partyDetailsArray().at(partyDetailsIndex).get('method')?.hasError('required')"
                              >*Select Signatory Sign Method</span>
                            </div>

                            <div
                              *ngIf="
                                partyDetailsArray().at(partyDetailsIndex).get('method')?.value === 'AADHAAR' &&
                                aadhaar_validation &&
                                isDocumentType === '003'
                              "
                              class="col-lg-4 col-sm-4 col-md-4 overlay_Z_1"
                            >
                              <div id="aadhaarVerification">
                                <span class="form_field">
                                  Enter last 4 digits of Aadhaar<span class="color_red">*</span>
                                </span>
                                <input
                                  class="form-control edit_input"
                                  formControlName="aadhaar_digits"
                                  placeholder="Enter Digit here"
                                  pInputText
                                  type="text"
                                  (keypress)="numberOnlyForAdhar($event)"
                                  [maxlength]="4"
                                  [minlength]="4"
                                />
                              </div>
                            </div>

                            <div
                              *ngIf="
                                partyDetailsArray().at(partyDetailsIndex).get('method')?.value === 'AADHAAR' &&
                                showSignMode &&
                                isDocumentType === '003'
                              "
                              class="col-lg-4 col-sm-4 col-md-4 overlay_Z_1"
                            >
                              <div id="aadhaarVerification">
                                <span class="form_field">Sign Mode<span class="color_red">*</span></span><br />
                                <app-dropdown
                                  class="custom-dropdown"
                                  [options]="aadhaarVerificationMethod"
                                  formControlName="sign_mode"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select"
                                  [autoDisplayFirst]="false"
                                  optionDisabled="inactive"
                                  (onChange)="onAadhaarVerficationMethodChange($event)"
                                  [ngClass]="{'ng-invalid ng-dirty': submitted && partyDetailsArray().at(partyDetailsIndex).get('method')?.errors}"
                                ></app-dropdown>
                                <div
                                  *ngIf="partyDetailsArray().at(partyDetailsIndex).get('sign_mode')?.value === 'FaceRecognition'"
                                  class="notification-message mt-2 p-2 rounded"
                                  style="background-color: #e3f2fd; border-left: 4px solid #2196f3; font-size: 0.75rem; color: #1976d2"
                                >
                                  <i class="fa fa-info-circle me-1"></i>
                                  Face Recognition will only work on Android mobile devices.
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-4 col-sm-4 col-md-4 overlay_Z_1">
                              <span class="form_field">Select {{ partyDetailsIndex + 1 }} Signature Placement</span>
                              <span class="color_red">*</span>
                              <app-dropdown
                               *ngIf="!isDefaultSignatureSelected"
                                class="custom-dropdown"
                                placeholder="Select"
                                [options]="signPlacementNomal"
                                (onChange)="getPlacementType(partyDetailsIndex)"
                                [autoDisplayFirst]="false"
                                optionLabel="name"
                                optionValue="value"
                                optionDisabled="disabled"
                                formControlName="signature_placement_type"
                              ></app-dropdown>
                              <div class="flex_row">
                             <input
                              *ngIf="isDefaultSignatureSelected"
                              class="custom-dropdown"
                              pInputText
                              type="text"
                              value="Default"
                              readonly
                              style="cursor:default; background-color: #e9ecef;"
                            />
                            </div>
                            </div>
                            <span
                              class="p-error"
                              style="font-size: 0.5rem; margin-top: 0.5rem"
                              *ngIf="submitted && partyDetailsArray().at(partyDetailsIndex).get('signature_placement_type')?.hasError('required')"
                            >*Select Signature Placement</span>

                            <div
                              *ngIf="showPredefined[partyDetailsIndex] && !isDefaultSignatureSelected"
                              class="col-lg-4 col-sm-4 col-md-4 mt-1 ml-2 overlay_Z_1"
                            >
                              <span class="form_field">Select {{ partyDetailsIndex + 1 }} Signatory sign position</span>
                              <span class="color_red">*</span>
                              <app-dropdown
                                class="custom-dropdown"
                                [options]="signatoryAvailablePositions[partyDetailsIndex] || displaySigningPositions"
                                formControlName="sign_position"
                                optionLabel="display_name"
                                optionValue="position_code"
                                optionDisabled="disabled"
                                placeholder="Select"
                                [autoDisplayFirst]="false"
                                (onChange)="selectedSignPotion(partyDetailsIndex)"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && partyDetailsArray().at(partyDetailsIndex).get('sign_position')?.errors}"
                              >
                                <ng-template let-option pTemplate="item">
                                  <div [attr.disabled]="option.disabled ? true : null">
                                    {{ option.display_name }}
                                  </div>
                                </ng-template>
                              </app-dropdown>
                            </div>

                            <div *ngIf="showPredefined[partyDetailsIndex] || isDefaultSignatureSelected" class="col-lg-4 col-sm-4 col-md-4 mt-1 estamp">
                              <span class="form_field">Select Pages to Sign</span>
                              <span class="color_red">*</span>
                              <div class="flex_row">
                                <input
                                  class="form-control edit_input"
                                  formControlName="pages"
                                  placeholder="Enter Page number with ',' between "
                                  pInputText
                                  type="text"
                                  (keypress)="numberOnlyWithComma($event)"
                                  (blur)="onPredefinedPagesChange(partyDetailsIndex)"
                                  [attr.disabled]="service.toUpperCase() == 'MULTIPLE-STAMP' ? true : null"
                                />
                                <p-button
                                  class="ms-2"
                                  type="button"
                                  label="ALL"
                                  styleClass="p-button-sm-outline"
                                  (onClick)="SetPageALL(partyDetailsIndex)"
                                  pTooltip="Click to Sign 'ALL' pages"
                                  [disabled]="service.toUpperCase() == 'MULTIPLE-STAMP'"
                                ></p-button>
                                <p-button
                                  class="ms-2"
                                  type="button"
                                  icon="pi pi-question-circle"
                                  styleClass="p-button-sm-outline custom-help-btn"
                                  pTooltip="Enter Page Number you want to sign . (Ex:- 1-4,6,9,12-20)"
                                  [disabled]="service.toUpperCase() == 'MULTIPLE-STAMP'"
                                ></p-button>
                                <div *ngIf="!showCatEdit">
                                  <div
                                    *ngIf="partyDetailsArray().at(partyDetailsIndex).get('pages')?.invalid && submitted"
                                    class="error-exceed"
                                  >
                                    ⚠ Page numbers must not exceed the document's total of {{ totalPages }} pages.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row mt-3 mb-2">
                            <div
                              style="display: flex"
                              *ngIf="partyDetailsArray().at(partyDetailsIndex).get('signature_placement_type').value === 'DRAG_DROP'"
                            >
                              <div class="custom_button_1 ms-2">
                                <p-button
                                  (click)="markSignaturePlacementDone(signatureAssignment, partyDetailsIndex)"
                                  [styleClass]="getButtonStyleClass(partyDetailsIndex)"
                                  [disabled]="isButtonDisabled(partyDetailsIndex)"
                                >
                                  <ng-container *ngIf="shouldShowCheckmark(partyDetailsIndex); else assignLabel">
                                    <span style="color: white; font-size: 18px; vertical-align: middle">&#10003;</span>
                                    <span style="color: white; font-weight: bold; margin-left: 6px" class="p-button-label">
                                      {{ getButtonLabel(partyDetailsIndex) }}
                                    </span>
                                  </ng-container>
                                  <ng-template #assignLabel>
                                    <span class="p-button-label">{{ getButtonLabel(partyDetailsIndex) }}</span>
                                  </ng-template>
                                </p-button>
                              </div>
                              <div>
                                <p style="float: left; font-size: 0.7rem; margin-left: 10px; margin-top: 3px">
                                  (For placing signature through drag and drop,<br />
                                  please click on the Assign Signatures button).
                                  <span *ngIf="hasSignaturesPlaced(partyDetailsIndex)" style="color: #612e86">
                                    <br />{{ getSignatureCount(partyDetailsIndex) }} signature(s) placed.
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>

                          <div *ngIf="contractType && isEsigned">
                            <form formGroupName="additional_fields">
                              <strong class="m-1 mt-2 title_header_0">Additional Sign Details</strong>
                              <div class="row form_inputFields">
                                <div *ngFor="let item of formData" class="col-12 col-md-4">
                                  <div *ngFor="let key of objectKeys(item)">
                                    <div *ngIf="item[key]?.module === 'esign.signatory'">
                                      <ng-container [ngSwitch]="item[key]?.data_type">
                                        <ng-container *ngIf="item[key]?.data_type !== 'OT' || isSelectedOT(partyDetailsIndex)">
                                          <span class="form_field">{{ item[key]?.label }}</span>
                                          <span *ngIf="item[key]?.mandatory" class="color_red">*</span>
                                        </ng-container>
                                        <div class="flex_row custom-input">
                                          <input
                                            *ngSwitchCase="'text'"
                                            class="form-control"
                                            [formControlName]="key"
                                            [placeholder]="item[key]?.label"
                                            type="text"
                                            pInputText
                                          />
                                        </div>
                                        <div class="flex_row custom-input" *ngIf="isSelectedOT(partyDetailsIndex)">
                                          <input
                                            *ngSwitchCase="'OT'"
                                            class="form-control"
                                            [formControlName]="key"
                                            [placeholder]="item[key]?.label"
                                            type="text"
                                            pInputText
                                          />
                                        </div>
                                        <select
                                          *ngSwitchCase="'dropdown'"
                                          [formControlName]="key"
                                          (change)="onSelectionDropDown(partyDetailsIndex, key, $event.target['value'])"
                                          class="form-select"
                                        >
                                          <option value="" disabled selected>Select {{ item[key]?.label }}</option>
                                          <option
                                            *ngFor="let option of getFilteredOptions(item[key]?.options, key, partyDetailsIndex)"
                                            [value]="getOptionKey(option)"
                                          >
                                            {{ getOptionValue(option) }}
                                          </option>
                                        </select>
                                        <div class="flex_row custom-input">
                                          <input
                                            *ngSwitchCase="'date'"
                                            type="date"
                                            pInputText
                                            class="form-control"
                                            [placeholder]="item[key]?.label"
                                            [formControlName]="key"
                                          />
                                        </div>
                                        <span
                                          class="p-error"
                                          style="font-size: 0.5rem"
                                          *ngIf="partyDetailsArray().at(partyDetailsIndex).get('additional_fields').get(key)?.invalid && submitted"
                                        >This {{ item[key]?.label }} is required.</span>
                                      </ng-container>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                *ngIf="partyDetailsIndex > 1"
                                style="padding-top: 15px"
                                class="col-lg-1 col-sm-1 col-md-1 remove_btn"
                              >
                                <button
                                  pButton
                                  pRipple
                                  type="button"
                                  icon="pi pi-trash"
                                  (click)="removePartyDetails(partyDetailsIndex)"
                                  class="p-button-sm"
                                ></button>
                              </div>
                            </form>
                          </div>

                          <div *ngIf="!contractType" class="row mt-1">
                            <div *ngIf="displayMailSchedule" class="col-lg-4 col-sm-4 col-md-4 overlay_Z_1">
                              <span class="form_field me-2">Email Schedule</span>
                              <input
                                class="form-control edit_input"
                                placeholder="Enter Schedule Time"
                                pInputText
                                [min]="minDate[0]"
                                [max]="maxDate"
                                (change)="onDateSelected(partyDetailsIndex)"
                                formControlName="schedule_timestamp"
                                type="datetime-local"
                                id="datetime"
                                name="datetime"
                              />
                              <span class="p-error" *ngIf="scheduleError[partyDetailsIndex]">
                                Value must be later than
                                <span style="font-weight: 700">{{ selectedDateValue[partyDetailsIndex] }}</span>.
                              </span>
                            </div>
                            <div class="col-lg-4 col-sm-4 col-md-4">
                              <span class="form_field me-2"> Remark</span>
                              <textarea
                                class="form-control edit_input me-2"
                                formControlName="remark"
                                placeholder="Enter"
                                style="min-height: 3rem"
                                pInputText
                                type="text"
                              ></textarea>
                              <span
                                class="p-error"
                                *ngIf="submitted && partyDetailsArray().at(partyDetailsIndex).get('remark')?.hasError('required')"
                              >*Maximum of 500 characters</span>
                            </div>
                            <div
                              *ngIf="partyDetailsIndex != 0"
                              style="padding-top: 15px"
                              class="col-lg-1 col-sm-1 col-md-1 remove_btn"
                            >
                              <button
                                pButton
                                pRipple
                                type="button"
                                icon="pi pi-trash"
                                (click)="removePartyDetails(partyDetailsIndex)"
                                class="p-button-sm"
                              ></button>
                            </div>
                          </div>

                          <div *ngIf="!contractType" class="row">
                            <div class="col-lg-4 col-sm-4 col-md-4 mt-4 estamp">
                              <div class="flex_row">
                                <div class="flex_row ms-1 me-2">
                                  <p style="font-size: 0.7rem">Send Signed Document ?</p>
                                </div>
                                <div class="flex_row p-field-radiobutton radio_btn">
                                  <input
                                    type="radio"
                                    [formControl]="details.get('send_document')"
                                    [value]="signedDocumentYes"
                                    name="{{ 'send_document_party_' + partyDetailsIndex }}"
                                  />
                                  <label class="me-1 ms-1 font_size_12" for="toOrder">Yes</label>
                                </div>
                                <div class="flex_row p-field-radiobutton radio_btn ms-3">
                                  <input
                                    type="radio"
                                    [formControl]="details.get('send_document')"
                                    [value]="signedDocumentNo"
                                    name="{{ 'send_document_party_' + partyDetailsIndex }}"
                                  />
                                  <label class="me-1 ms-1 font_size_12" for="toOrder">No</label>
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-3 col-sm-4 col-md-3 mt-4 estamp">
                              <div class="flex_row">
                                <div class="flex_row ms-1 me-2">
                                  <p style="font-size: 0.7rem">Send Notification ?</p>
                                </div>
                                <div class="flex_row p-field-radiobutton radio_btn">
                                  <input
                                    type="radio"
                                    [formControl]="details.get('send_notification')"
                                    [value]="sendNotificationYes"
                                    name="{{ 'send_notification_party_' + partyDetailsIndex }}"
                                  />
                                  <label class="me-1 ms-1 font_size_12" for="toOrder">Yes</label>
                                </div>
                                <div class="flex_row p-field-radiobutton radio_btn ms-3">
                                  <input
                                    type="radio"
                                    [formControl]="details.get('send_notification')"
                                    [value]="sendNotificationNo"
                                    name="{{ 'send_notification_party_' + partyDetailsIndex }}"
                                  />
                                  <label class="me-1 ms-1 font_size_12" for="toOrder">No</label>
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-3 col-sm-4 col-md-3 mt-4 estamp" *ngIf="stampSignToggle && documentToBeStamped">
                              <div class="flex_row">
                                <div class="flex_row ms-1 me-2">
                                  <p style="font-size: 0.7rem">E-Stamp Sign ?</p>
                                </div>
                                <div class="flex_row p-field-radiobutton radio_btn">
                                  <input
                                    type="radio"
                                    [formControl]="details.get('estamp_sign')"
                                    [value]="estampSignYes"
                                    name="{{ 'estamp_sign_party_' + partyDetailsIndex }}"
                                  />
                                  <label class="me-1 ms-1 font_size_12" for="toOrder">Yes</label>
                                </div>
                                <div class="flex_row p-field-radiobutton radio_btn ms-3">
                                  <input
                                    type="radio"
                                    [formControl]="details.get('estamp_sign')"
                                    [value]="estampSignNo"
                                    name="{{ 'estamp_sign_party_' + partyDetailsIndex }}"
                                  />
                                  <label class="me-1 ms-1 font_size_12" for="toOrder">No</label>
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-4 col-sm-4 col-md-4 mt-4 estamp" *ngIf="isAuthorisedSignatureEnabled && !isDefaultSignatureSelected">
                              <div class="flex_row" style="flex-wrap: wrap;">
                                <div class="flex_row ms-1 me-2">
                                  <p style="font-size: 0.7rem">Do you want to Authorise the signature?</p>
                                </div>
                                <div
                                  class="flex_row p-field-radiobutton radio_btn"
                                  pTooltip="Enabling this will hide and disable 'Add auto electronic signature?' for this signatory — the two cannot be used together"
                                  tooltipPosition="bottom"
                                >
                                  <input
                                    type="radio"
                                    [formControl]="details.get('is_authorised')"
                                    [value]="true"
                                    [id]="'isAuthorisedYes_' + partyDetailsIndex"
                                    [name]="'is_authorised_party_' + partyDetailsIndex"
                                  />
                                  <label class="me-1 ms-1 font_size_12" [for]="'isAuthorisedYes_' + partyDetailsIndex">Yes</label>
                                </div>
                                <div class="flex_row p-field-radiobutton radio_btn ms-3">
                                  <input
                                    type="radio"
                                    [formControl]="details.get('is_authorised')"
                                    [value]="false"
                                    [id]="'isAuthorisedNo_' + partyDetailsIndex"
                                    [name]="'is_authorised_party_' + partyDetailsIndex"
                                  />
                                  <label class="me-1 ms-1 font_size_12" [for]="'isAuthorisedNo_' + partyDetailsIndex">No</label>
                                </div>
                              </div>
                              <div class="mt-2" *ngIf="details.get('is_authorised')?.value">
                                <span class="form_field me-2">Authorised For</span>
                                <span class="color_red">*</span>
                                <input
                                  class="form-control edit_input"
                                  [formControl]="details.get('authorised_for')"
                                  placeholder="Enter Authorised For"
                                  pInputText
                                  type="text"
                                />
                                <span
                                  class="p-error"
                                  style="font-size: 0.5rem"
                                  *ngIf="submitted && details.get('is_authorised')?.value && !details.get('authorised_for')?.value"
                                >*Enter Authorised For</span>
                              </div>
                            </div>

                            <div
                              class="col-lg-5 col-sm-4 col-md-5 mt-4 estamp"
                              *ngIf="isElectronicMethod(partyDetailsIndex) && isAutoEsign && partyDetailsArray().length > 1 && !details.get('is_authorised')?.value"
                            >
                              <div class="flex_row" *ngIf="!sequentialSign">
                                <div class="flex_row ms-1 me-2">
                                  <p style="font-size: 0.7rem">Do you want add auto electronic signature ?</p>
                                </div>
                                <div class="flex_row p-field-radiobutton radio_btn">
                                  <input
                                    type="radio"
                                    [formControl]="details.get('server_side_siganture')"
                                    [value]="serverSideYes"
                                    [name]="'radio_' + partyDetailsIndex"
                                    [id]="'serverSideYes_' + partyDetailsIndex"
                                    [checked]="details.get('server_side_siganture')?.value === serverSideYes"
                                    [disabled]="!canThisSignatorySelectYes(partyDetailsIndex)"
                                    (click)="handleYesRadioClick(partyDetailsIndex, $event)"
                                  />
                                  <label
                                    class="me-1 ms-1 font_size_12"
                                    [for]="'serverSideYes_' + partyDetailsIndex"
                                    [class.text-muted]="!canThisSignatorySelectYes(partyDetailsIndex)"
                                    (click)="handleYesRadioClick(partyDetailsIndex, $event)"
                                  >Yes</label>
                                </div>
                                <div class="flex_row p-field-radiobutton radio_btn ms-3">
                                  <input
                                    type="radio"
                                    [formControl]="details.get('server_side_siganture')"
                                    [value]="serverSideNo"
                                    [name]="'radio_' + partyDetailsIndex"
                                    [id]="'serverSideNo_' + partyDetailsIndex"
                                    [checked]="details.get('server_side_siganture')?.value === serverSideNo"
                                    (click)="onAutoSignatureChange(partyDetailsIndex, serverSideNo)"
                                  />
                                  <label
                                    class="me-1 ms-1 font_size_12"
                                    [for]="'serverSideNo_' + partyDetailsIndex"
                                    (click)="onAutoSignatureChange(partyDetailsIndex, serverSideNo)"
                                  >No</label>
                                </div>
                              </div>
                              <div
                                class="notification-message mt-2 p-2 rounded"
                                *ngIf="details.get('server_side_siganture')?.value === serverSideYes && !sequentialSign"
                                style="background-color: #e3f2fd; border-left: 4px solid #2196f3; font-size: 0.75rem; color: #1976d2"
                              >
                                <i class="fa fa-info-circle me-1"></i>
                                Auto signature works when signatory email matches your saved signature email. Otherwise, normal flow applies.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>

                <div class="custom_button_2 me-2 mt-3 addSign">
                  <p-button
                    icon="pi pi-plus"
                    label="Add Signatory"
                    (click)="addNewPartyDetails()"
                    styleClass="p-button-sm"
                  ></p-button>
                </div>
              </div>
            </div>

            <div *ngIf="showWitnessDetails" class="row mt-2 form_inputFields">
              <div class="col-12 mt-2">
                <h5 class="title_five">Witness Details</h5>
                <div formArrayName="addWitnessDetailsForm">
                  <section
                    #witnessRow
                    class="signatory-row"
                    *ngFor="let details of witnessDetailsArray().controls; let witnessDetailsIndex = index; trackBy: trackByControl"
                    [formGroupName]="witnessDetailsIndex"
                  >
                    <div class="form_outline_sty">
                      <div class="row">
                        <div *ngIf="displayOrderIndex" class="col-lg-1 col-md-2 col-3">
                          <div>
                            <span class="form_field">Order</span><span class="color_red">*</span>
                            <input
                              class="form-control edit_input"
                              formControlName="signatory_sequence"
                              (keypress)="numberOnly($event)"
                              (change)="orderChange(witnessDetailsIndex, 'WITNESS')"
                              [min]="1"
                              pInputText
                              type="text"
                            />
                          </div>
                          <div class="col-lg-1 col-sm-1 col-md-1 order_btn">
                            <button
                              *ngIf="witnessDetailsIndex != 0"
                              pButton
                              pRipple
                              type="button"
                              icon="pi pi-angle-double-up"
                              (click)="decreseOrder(witnessDetailsIndex, 'WITNESS')"
                              class="p-button-sm ms-1"
                            ></button>
                            <button
                              *ngIf="witnessDetailsIndex === witnessDetailsIndex"
                              pButton
                              pRipple
                              type="button"
                              icon="pi pi-angle-double-down"
                              (click)="increaseOrder(witnessDetailsIndex, 'WITNESS')"
                              class="p-button-sm ms-1 mt-1"
                            ></button>
                          </div>
                        </div>
                        <div class="col-11">
                          <div class="row">
                            <div class="col-lg-4 col-sm-4 col-md-4">
                              <span class="form_field">{{ witnessDetailsIndex + 1 }} Witness' Name</span>
                              <span class="color_red">*</span>
                              <input
                                class="form-control edit_input"
                                formControlName="name"
                                placeholder="Enter Name"
                                pInputText
                                type="text"
                              />
                              <span
                                class="p-error"
                                style="font-size: 0.5rem"
                                *ngIf="submitted && witnessDetailsArray().at(witnessDetailsIndex).get('name')?.hasError('required')"
                              >*Maximum of 100 characters</span>
                            </div>
                            <div class="col-lg-4 col-sm-4 col-md-4">
                              <span class="form_field">{{ witnessDetailsIndex + 1 }} Witness' email</span>
                              <span class="color_red">*</span>
                              <input
                                class="form-control edit_input"
                                formControlName="email"
                                placeholder="Enter Email"
                                pInputText
                                type="text"
                              />
                              <span
                                class="p-error"
                                style="font-size: 0.5rem"
                                *ngIf="submitted && witnessDetailsArray().at(witnessDetailsIndex).get('email')?.hasError('required')"
                              >*Enter valid Email</span>
                            </div>
                            <div class="col-lg-3 col-sm-3 col-md-3">
                              <span class="form_field">{{ witnessDetailsIndex + 1 }} Witness' Mobile</span>
                              <input
                                class="form-control edit_input"
                                formControlName="contact_number"
                                minlength="10"
                                maxlength="10"
                                placeholder="Enter Number"
                                pInputText
                                type="text"
                                (keypress)="numberOnly($event)"
                              />
                              <span
                                class="p-error"
                                style="font-size: 0.5rem"
                                *ngIf="submitted && witnessDetailsArray().at(witnessDetailsIndex).get('contact_number')?.hasError('required')"
                              >*Mobile Number is required</span>
                              <span
                                class="p-error"
                                style="font-size: 0.5rem"
                                *ngIf="
                                  witnessDetailsArray().at(witnessDetailsIndex).get('contact_number')?.hasError('maxlength') ||
                                  witnessDetailsArray().at(witnessDetailsIndex).get('contact_number')?.hasError('minlength')
                                "
                              >*Enter Valid Mobile Number</span>
                            </div>
                            <div style="padding-top: 15px" class="col-lg-1 col-sm-1 col-md-1 remove_btn">
                              <button
                                pButton
                                pRipple
                                type="button"
                                icon="pi pi-trash"
                                (click)="removeWitnessDetails(witnessDetailsIndex)"
                                class="p-button-sm"
                              ></button>
                            </div>
                          </div>

                          <div class="row mt-1">
                            <div class="col-lg-4 col-sm-4 col-md-4 mt-1 ml-3 overlay_Z_1">
                              <span class="form_field">Select {{ witnessDetailsIndex + 1 }} Witness Sign Method</span>
                              <span class="color_red">*</span>
                              <app-dropdown
                                class="custom-dropdown"
                                [options]="signMethod"
                                formControlName="method"
                                optionLabel="name"
                                optionValue="code"
                                placeholder="Select"
                                [autoDisplayFirst]="false"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && witnessDetailsArray().at(witnessDetailsIndex).get('method')?.errors}"
                              ></app-dropdown>
                            </div>
                            <div class="col-lg-4 col-sm-4 col-md-4 overlay_Z_1">
                              <span class="form_field">Select Signature Placement</span>
                              <span class="color_red">*</span>
                              <app-dropdown
                                class="custom-dropdown"
                                placeholder="Select"
                                [options]="signPlacementNomal"
                                (onChange)="getPlacementTypeWitness(witnessDetailsIndex)"
                                [autoDisplayFirst]="false"
                                optionLabel="name"
                                optionValue="value"
                                formControlName="signature_placement_type"
                              ></app-dropdown>
                            </div>
                            <div
                              *ngIf="showPredefinedWitness[witnessDetailsIndex]"
                              class="col-lg-3 col-sm-3 col-md-3 mt-1 ml-2 overlay_Z_1"
                            >
                              <span class="form_field">{{ witnessDetailsIndex + 1 }} Witness sign position</span>
                              <span class="color_red">*</span>
                              <app-dropdown
                                class="custom-dropdown"
                                [options]="displaySigningPositions"
                                formControlName="sign_position"
                                optionLabel="display_name"
                                optionValue="position_code"
                                placeholder="Select"
                                [autoDisplayFirst]="false"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && witnessDetailsArray().at(witnessDetailsIndex).get('sign_position')?.errors}"
                              ></app-dropdown>
                            </div>
                          </div>

                          <div class="row">
                            <div
                              class="col-lg-4 col-sm-4 col-md-4 mt-3"
                              *ngIf="witnessDetailsArray().at(witnessDetailsIndex).get('sign_position').value == 'DRAG_DROP'"
                            >
                              <div class="custom_button_1 ms-4">
                                <p-button
                                  label="Assign Signatures"
                                  (click)="assignSignatures(signatureAssignment)"
                                  styleClass="p-button-sm"
                                ></p-button>
                              </div>
                              <div>
                                <p style="float: left; font-size: 0.5rem; margin-top: 10px">
                                  (To place a signature through drag and drop, please click on the 'Assign Signatures' button).
                                </p>
                              </div>
                            </div>
                            <div *ngIf="showPredefinedWitness[witnessDetailsIndex]" class="col-lg-4 col-sm-4 col-md-4 estamp">
                              <span class="form_field">Select Pages</span><span class="color_red">*</span>
                              <div class="flex_row">
                                <input
                                  class="form-control edit_input"
                                  formControlName="pages"
                                  placeholder="Enter Page number with ',' between "
                                  pInputText
                                  type="text"
                                  (keypress)="numberOnlyWithComma($event)"
                                />
                                <p-button
                                  class="ms-2"
                                  type="button"
                                  icon="pi pi-question-circle"
                                  styleClass="p-button-sm-outline"
                                  pTooltip="Enter Page Number you want to sign . (Ex:- 1-4,6,9,12-20)"
                                ></p-button>
                                <div
                                  *ngIf="partyDetailsArray().at(witnessDetailsIndex).get('pages')?.invalid && submitted"
                                  class="error-exceed"
                                >
                                  ⚠ Page numbers must not exceed the document's total of {{ totalPages }} pages.
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-4 col-sm-4 col-md-4">
                              <span class="form_field"> Remark</span>
                              <textarea
                                class="form-control edit_input"
                                formControlName="remark"
                                placeholder="Enter"
                                pInputText
                                type="text"
                              ></textarea>
                              <span
                                class="p-error"
                                *ngIf="submitted && partyDetailsArray().at(witnessDetailsIndex).get('remark')?.hasError('required')"
                              >*Maximum of 500 characters</span>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-lg-4 col-sm-4 col-md-4 mt-4 estamp">
                              <div class="flex_row">
                                <div class="flex_row ms-1 me-2">
                                  <p style="font-size: 0.7rem">Send Signed Document ?</p>
                                </div>
                                <div class="flex_row p-field-radiobutton radio_btn">
                                  <input
                                    type="radio"
                                    [formControl]="details.get('send_document')"
                                    [value]="signedDocumentYes"
                                    name="{{ 'send_document_witness_' + witnessDetailsIndex }}"
                                  />
                                  <label class="me-1 ms-1 font_size_12" for="toOrder">Yes</label>
                                </div>
                                <div class="flex_row p-field-radiobutton radio_btn ms-3">
                                  <input
                                    type="radio"
                                    [formControl]="details.get('send_document')"
                                    [value]="signedDocumentNo"
                                    name="{{ 'send_document_witness_' + witnessDetailsIndex }}"
                                  />
                                  <label class="me-1 ms-1 font_size_12" for="toOrder">No</label>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-3 col-sm-4 col-md-3 mt-4 estamp">
                              <div class="flex_row">
                                <div class="flex_row ms-1 me-2">
                                  <p style="font-size: 0.7rem">Send Notification ?</p>
                                </div>
                                <div class="flex_row p-field-radiobutton radio_btn">
                                  <input
                                    type="radio"
                                    [formControl]="details.get('send_notification')"
                                    [value]="sendNotificationYes"
                                    name="{{ 'send_notification_witness_' + witnessDetailsIndex }}"
                                  />
                                  <label class="me-1 ms-1 font_size_12" for="toOrder">Yes</label>
                                </div>
                                <div class="flex_row p-field-radiobutton radio_btn ms-3">
                                  <input
                                    type="radio"
                                    [formControl]="details.get('send_document')"
                                    [value]="sendNotificationNo"
                                    name="{{ 'send_notification_witness_' + witnessDetailsIndex }}"
                                  />
                                  <label class="me-1 ms-1 font_size_12" for="toOrder">No</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
                <div class="custom_button_2 addSign me-2 mt-3" style="margin-left: 7px">
                  <!-- <p-button icon="pi pi-plus" label="Add Witness" (click)="addNewWitnessDetails()" styleClass="p-button-sm"></p-button> -->
                </div>
              </div>
            </div>

            <div class="flex_row mt-3">
              <div *ngIf="!showSignaotryDetails" class="custom_button_2 me-2">
                <p-button
                  icon="pi pi-plus"
                  label="Add Signatory"
                  (click)="addNewPartyDetails()"
                  styleClass="p-button-sm"
                ></p-button>
              </div>
              <div *ngIf="!showWitnessDetails" class="custom_button_2 me-2">
                <!-- <p-button icon="pi pi-plus" label="Add Witness" (click)="addNewWitnessDetails()" styleClass="p-button-sm"></p-button> -->
              </div>
            </div>
          </div>

          <div *ngIf="(showPayment && !hidePaymentMethod ) || is_wallet">
            <div class="row mt-3">
              <p class="title_five" style="font-size: 1rem; color: black">Payment method</p>
            </div>
            <div class="flex_row payment-method-radios mt-2">
              <div *ngIf="is_wallet" class="flex_row p-field-radiobutton radio_btn align-items-center">
                <input
                  type="radio"
                  id="wallet"
                  name="paymentMethod"
                  (click)="paymentMethod(paymentbyWallet)"
                  formControlName="paymentMethod"
                  [value]="paymentbyWallet"
                />
                <label class="me-1 ms-1" style="font-size: 0.8rem" for="wallet">Wallet</label>
              </div>
            <ng-container *ngIf="showPayment && !hidePaymentMethod">
              <div
                *ngIf="hasProvider('RAZORPAY_GATEWAY')"
                class="flex_row p-field-radiobutton radio_btn ms-3 align-items-center"
              >
                <input
                  type="radio"
                  id="razorpay"
                  name="paymentMethod"
                  (click)="paymentMethod(paymentbyRazorpay)"
                  formControlName="paymentMethod"
                  [value]="paymentbyRazorpay"
                />
                <label class="me-1 ms-1 d-flex" for="razorpay">
                  <img src="../../../assets/logos/razorpay_big_icon.svg" class="razorpay-logo me-1" alt="razorpay-logo" />
                </label>
              </div>
              <div
                *ngIf="hasProvider('HDFC_GATEWAY')"
                class="flex_row p-field-radiobutton radio_btn ms-3 align-items-center"
              >
                <input
                  type="radio"
                  id="hdfc_gateway"
                  name="paymentMethod"
                  (click)="paymentMethod('HDFC_GATEWAY')"
                  formControlName="paymentMethod"
                  [value]="'HDFC_GATEWAY'"
                />
                <label class="me-1 ms-1" style="font-size: 0.8rem" for="hdfc_gateway">
                  <img src="../../../assets/logos/HDFClogo.png" class="razorpay-logo me-1" alt="razorpay-logo" />
                </label>
              </div>
              <div *ngIf="!is_wallet" class="flex_row p-field-radiobutton align-items-center radio_btn ms-3">
                <input
                  type="radio"
                  id="pay_later"
                  name="paymentMethod"
                  (click)="paymentMethod(payLater)"
                  formControlName="paymentMethod"
                  [value]="payLater"
                />
                <label class="me-1 ms-1" style="font-size: 0.8rem" for="pay_later">Continue without payment</label>
              </div>
            </ng-container>
            </div>
          </div>
          <div class="mt-2" *ngIf="showPaymentDetails && showPayment">
            <div class="row form_inputFields form_outline_sty mt-2">
              <div class="col-lg-4 col-sm-4 col-md-4">
                <span class="form_field">Payee Name</span><span class="color_red">*</span>
                <input
                  class="form-control edit_input"
                  formControlName="payeeName"
                  placeholder="Enter Name"
                  pInputText
                  type="text"
                  pattern="^[a-zA-Z\s]+$"
                   (input)="validatePayeeName()"
                />
                <span
                  class="p-error"
                  style="font-size: 0.5rem"
                  *ngIf="submitted && esignDetails.get('payeeName')?.hasError('required')"
                >*Enter Valid Name</span>
                 <span
                  class="p-error"
                  style="font-size: 0.5rem"
                  *ngIf="
                  !esignDetails.get('payeeName')?.hasError('required') &&
                  esignDetails.get('payeeName')?.hasError('spaceNotAllowed')
                  "
                >
                *Space is not allowed at the beginning or end
                 </span>

                <span
                  class="p-error"
                  style="font-size: 0.5rem"
                  *ngIf="submitted && esignDetails.get('payeeName')?.hasError('pattern')"
                >*Special characters and numbers are not allowed</span>
              </div>
          
              <div class="col-lg-4 col-sm-4 col-md-4">
                <span class="form_field">Payee Email</span><span class="color_red">*</span>
                <input
                  class="form-control edit_input"
                  formControlName="payeeEmail"
                  placeholder="Enter Email"
                  pInputText
                  type="text"
                />
                <span
                  class="p-error"
                  style="font-size: 0.5rem"
                  *ngIf="submitted && esignDetails.get('payeeEmail')?.hasError('required')"
                >*Enter Valid Email</span>
              </div>
              <div class="col-lg-4 col-sm-4 col-md-4">
                <span class="form_field">Payee Contact</span><span class="color_red">*</span>
                <input
                  class="form-control edit_input"
                  formControlName="payeeMobileNumber"
                  placeholder="Enter Number"
                  pInputText
                  type="text"
                  (keypress)="numberOnly($event)"
                  minlength="10"
                  maxlength="10"
                />
                <span
                  class="p-error"
                  style="font-size: 0.5rem"
                  *ngIf="submitted && esignDetails.get('payeeMobileNumber')?.hasError('required')"
                >*Enter Valid Mobile Number</span>
              </div>
            </div>
          </div>

          <div class="flex_row mt-4 d-flex justify-content-between">
            <div class="col-lg-1 col-sm-1 col-md-1 text-left">
              <p-button label="Back" (click)="back()" styleClass="p-button-sm-outline"></p-button>
            </div>
            <div class="col-lg-6 col-sm-6 col-md-6"></div>
            <div class="col-lg-1 col-sm-1 col-md-1"></div>
            <div class="col-lg-1 col-sm-1 col-md-1"></div>
            <div>
              <div class="col-lg-1 col-sm-1 col-md-1 me-4">
                <ng-container *ngIf="service?.toUpperCase() === 'MULTIPLE-STAMP'">
                  <div>
                    <p-button
                      [disabled]="showPlaceOrder || esignDetails.get('paymentMethod')?.value === paymentbyRazorpay || esignDetails.get('paymentMethod')?.value === 'HDFC_GATEWAY'"
                      label="Save as Draft"
                      styleClass="p-button-sm-outline p-button-purple w-full"
                      (click)="onDraftToggle()"
                    ></p-button>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="col-lg-1 col-sm-1 col-md-1 text-right">
              <div class="custom_button">
                <p-button
                  [disabled]="showPlaceOrder || isSignaturePlacementInvalid"
                  label="Place Order"
                  (click)="sendSignerDetails(); parentIsDraftFalse()"
                  styleClass="p-button-sm-outline"
                ></p-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<ng-template #confirmationModal let-modal>
  <div class="modal-header p-3">
    <h5 class="modal-title m-0">Confirm Action</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cancel')"></button>
  </div>
  <div class="modal-body p-3">
    <p class="m-0" style="font-size: 14px;">
      Changing this option will remove all additional signatories and reset signature placement. Are you sure you want to continue?
    </p>
  </div>
  <div class="modal-footer p-2">
    <div class="col-lg-6 col-sm-6 col-md-6 text-right custom_button">
        <p-button label="Cancel" (click)="modal.dismiss('Cancel')" styleClass="p-button-sm"></p-button>
        </div>
        <div class="custom_button">
         <p-button
          label="Okay"
          styleClass="p-button-sm-outline"
          (click)="modal.close('Okay')"
          ></p-button>
     </div>
  </div>
</ng-template>

<ng-template #signatureAssignment let-modal>
  <div>
    <div class="signature-assignment-header">
      <h4 class="title_five" id="modal-basic-title">Assign Signature Position</h4>
      <div class="signature-page-navigation" *ngIf="dragDrop">
        <button
          type="button"
          class="signature-page-arrow"
          [disabled]="dragDrop.currentPage <= 1"
          (click)="dragDrop.goToPage(dragDrop.currentPage - 1)"
        >
          <i class="pi pi-chevron-left"></i>
        </button>
        <span class="signature-page-label">Page</span>
        <input
          #pageInput
          type="number"
          [value]="dragDrop.currentPage"
          [min]="1"
          [max]="dragDrop.numPdfPages"
          (keyup.enter)="dragDrop.goToPage(pageInput.valueAsNumber)"
          class="signature-page-input"
        />
        <span class="signature-page-total">of {{ dragDrop.numPdfPages }}</span>
        <button
          type="button"
          class="signature-page-arrow"
          [disabled]="dragDrop.currentPage >= dragDrop.numPdfPages"
         (click)="dragDrop.goToPage(dragDrop.currentPage + 1)"
         >
     <i class="pi pi-chevron-right"></i>
     </button>
        <button
          type="button"
          class="signature-page-go"
          (click)="dragDrop.goToPage(pageInput.valueAsNumber)"
        >
          <i class="pi pi-arrow-right"></i>
          <span>Go</span>
        </button>
      </div>
      <button
        type="button"
        class="btn-close signature-assignment-close"
        data-bs-dismiss="modal"
        (click)="closeModel()"
        aria-label="Close"
      ></button>
    </div>
    <div
      class="modal-body"
      style="background-color: #f4f6fb; height: calc(100vh - 3.5rem); margin-top: 3.5rem; overflow-y: auto; padding: 0"
    >
      <app-drag-drop
        #dragDrop
        [signers]="dragDropSignerNames"
        [pdfSource]="pdfSource"
        [signatureDetails]="signPlacementDetails"
        [referenceMarkers]="predefinedReferenceMarkers"
        (submitEvent)="digioSignPosition($event)"
        (cancelEvent)="cancel($event)"
      ></app-drag-drop>
    </div>
  </div>
</ng-template>

<!-- No p-toast here: the host form's p-toast shares this MessageService,
     so a second one would show every message twice. -->
